import { AppImage } from '@workspace/ui/common';
import { sanityImageSrc } from '@/sanity/lib/image';
import { SanityImage } from '@workspace/interfaces';

interface ContactSupportImageProps {
  image?: SanityImage;
  imageAlt?: string;
}

export function ContactSupportImage({ image, imageAlt = 'Contact support image' }: ContactSupportImageProps) {
  if (!image?.asset?._ref && !image?.url) return null;

  const altText = image?.alt || imageAlt;

  return (
    <div className="order-1 md:order-0 hidden md:block">
      <div className="relative md:h-135.5 w-full md:w-101.5 overflow-hidden">
        <AppImage
          src={sanityImageSrc(image, { width: 406, height: 542 })}
          alt={altText}
          fill
          className="object-cover"
          sanityImage={image}
        />
      </div>
    </div>
  );
}
